import { RangeCalendarCell_default } from "../RangeCalendar/RangeCalendarCell.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DateRangePicker/DateRangePickerCell.vue?vue&type=script&setup=true&lang.ts
var DateRangePickerCell_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DateRangePickerCell",
	props: {
		date: {
			type: null,
			required: true
		},
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(RangeCalendarCell_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DateRangePicker/DateRangePickerCell.vue
var DateRangePickerCell_default = DateRangePickerCell_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DateRangePickerCell_default };
//# sourceMappingURL=DateRangePickerCell.js.map